import { Components } from "@thisgorilla/primate-ds";
import { motion } from "framer-motion";
import { useContext, useEffect, useRef } from "react";
import styled, { useTheme } from "styled-components";
import { CenterPanelContext } from ".";
import { OVERLAY_Z_INDEX } from "../../../../utils";
import { FlexColumn, FlexRow } from "../../../Common/Styles";
import { PostCardContent } from "./PostCard/PostCardContent";

export const OriginalPost = () => {
  const { typography } = useTheme();
  const {
    showOriginalPost,
    originalPostId,
    onOriginalPostBackButtonClicked,
    originalPostRef,
  } = useContext(CenterPanelContext);

  const showContent = originalPostId && showOriginalPost ? true : false;
  const titleRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (showContent && titleRef.current) {
      titleRef.current.scrollIntoView({ behavior: "auto", block: "center" });
    }
  }, [showContent]);

  return (
    <Container
      $showContent={showContent}
      ref={originalPostRef}
      key="original-post"
      $gapInPx={0}
      as={motion.div}
      initial={{ x: "36px", opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{ x: "36px", opacity: 0 }}
      transition={{ type: "tween", duration: 0.2, ease: "easeInOut" }}
    >
      <Title ref={titleRef} $gapInPx={16}>
        <Components.IconButton
          kind="Tertiary"
          disabled={false}
          iconType="ArrowLeft"
          onClick={onOriginalPostBackButtonClicked}
          size="Large"
        />
        <Components.Text
          text="Post"
          style={{ tokenStyle: typography.Heading.XXL }}
          fontWeight="font-weight-semibold"
        />
      </Title>
      <PostCardContent postId={originalPostId} />
    </Container>
  );
};

const Container = styled(FlexColumn)<{ $showContent: boolean }>(
  ({ $showContent, theme }) => `
  position: absolute;
  width: 100%;
  height: ${$showContent ? "auto" : "0px"};
  overflow: ${$showContent ? "auto" : "hidden"};
  
  z-index: ${OVERLAY_Z_INDEX};
  background: ${theme.Color.elevation.surface["surface-primary"].value};
  box-shadow: 2px 2px 24px 0px #0000001a;
  border-radius: 8px;
`
);
const Title = styled(FlexRow)`
  height: 88px;
  padding: 20px;
  border-bottom: 1px solid
    ${({ theme }) => theme.Color.border["ui-border-neutral"].value};
`;
